import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../app/applicationSlice";
import { RootState, RootThunk } from "../../../app/store";
import { LoadingState } from "../../../models/common";
import { emptyOf, Pagination } from "../../../models/pagination";
import { inventoryRecords } from "../../../models/inventoryRecords";
import { fromJson, } from "../../../models/inventoryRecords";
import * as service from "../../../services/inventoryRecords";
import { InventoryRecordsParams } from "../../../services/inventoryRecords";
interface InventoryRecords {
  InventoryRecord: [],
  Total: 0,
  Current: 1,
}

const initialState: InventoryRecords = {
  InventoryRecord: [],
  Total: 0,
  Current: 1,
};

const inventoryRecordsSlice = createSlice({
  name: "inventoryRecordsSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.InventoryRecord = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
  },
});

export const { setData, 
  setTotal,
  setCurrent,  } = inventoryRecordsSlice.actions;

  export const selectInventoryRecord = (state: RootState) => state.inventoryRecord.InventoryRecord

  export const selectTotal = (state: RootState) => state.inventoryRecord.Total
  
  export const selectCurrent = (state: RootState) => state.inventoryRecord.Current
  

export function getInventoryRecordsList(params: InventoryRecordsParams): RootThunk {
  return api(service.getInventoryRecords(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
      dispatch(setTotal(data.total))
  });
}


export default inventoryRecordsSlice.reducer;
